var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.33744 17.5383L3.71244 11.9133C3.53631 11.7372 3.43737 11.4983 3.43737 11.2492C3.43737 11.0001 3.53631 10.7613 3.71244 10.5852C3.88856 10.409 4.12743 10.3101 4.3765 10.3101C4.62557 10.3101 4.86444 10.409 5.04056 10.5852L9.06322 14.6094L9.06322 3.125C9.06322 2.87636 9.16199 2.6379 9.33781 2.46209C9.51362 2.28627 9.75208 2.1875 10.0007 2.1875C10.2494 2.1875 10.4878 2.28627 10.6636 2.46209C10.8394 2.6379 10.9382 2.87636 10.9382 3.125L10.9382 14.6094L14.9632 10.5867C15.1393 10.4106 15.3782 10.3117 15.6273 10.3117C15.8764 10.3117 16.1152 10.4106 16.2913 10.5867C16.4675 10.7628 16.5664 11.0017 16.5664 11.2508C16.5664 11.4999 16.4675 11.7387 16.2913 11.9148L10.6663 17.5398C10.5791 17.6273 10.4755 17.6966 10.3614 17.7438C10.2473 17.7911 10.125 17.8153 10.0016 17.8152C9.87808 17.815 9.75585 17.7905 9.64188 17.743C9.5279 17.6955 9.42444 17.6259 9.33744 17.5383Z",
    fill: "#343330"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.7d98d0015d02604fafc43527f206a88e.svg";
export { ForwardRef as ReactComponent };